// extracted by mini-css-extract-plugin
module.exports = {"light":"footer-module--light--2wdFa","dark":"footer-module--dark--1FHmt","footer-container":"footer-module--footer-container--23p34"};